import Vue from "vue";

export function HandleFilters(stateFilters, page_size) {
  // filterString: A string of the basic filter. Sometimes passed by the UI
  //               when initializing a default view
  //
  // filterState:  An Object containing various key:value pairs of filters
  //
  // page_size:    The number of items to show per page of pagination
  //
  // return:       A string formatted as an URL filter for the backend =)
  var result = "";
  for (let key in stateFilters) {
    if (String(stateFilters[key]).length > 0) {
      result += "&" + key + "=" + stateFilters[key];
    }
  }
  if (page_size && page_size > 0) {
    result += "&page_size=" + page_size;
  }
  if (result.length > 0) {
    return "?" + result.substring(1); // Strip the first "&" character =)
  } else {
    return "";
  }
}

export function QueryHasChanged(query, filters) {
  return JSON.stringify(query) != JSON.stringify(filters);
}

export function SetupFilters(that, mutationName, viewName) {
  // Re-hydrate the Vuex filter store.
  //
  // This gives priority to anything in the route query params. Else it
  // re-hydrates the filters based on any information that's in the Vuex store.
  //
  // that:            the "this" from the View that called this function
  // mutationName:    The Vuex mutation that updates the filter object
  // viewName:        The name of the View that called this function
  if (Object.keys(that.$route.query).length > 0) {
    // If there's a query string in the URL then use this by default
    that.$store.commit(mutationName, that.$route.query);
  } else if (QueryHasChanged(that.$route.query, that.filters)) {
    // if (this.$route.query !== current filters) then update the URL
    // Update the URL with anything previously in the filter model
    that.$router.replace({ name: viewName, query: { ...that.filters } });
  }
}

export function MutateFilter(state, payload) {
  // state:   A 'state' object from the Vuex store
  // payload: An Object with key:val pairs of filters
  for (let [key, val] of Object.entries(payload)) {
    if (!val || val.length == 0) {
      Vue.delete(state.filters, key);
    } else {
      Vue.set(state.filters, key, val);
    }
  }
}

export function HandleDeselectedFilter(filterVal, value) {
  if (filterVal && filterVal == value) {
    // Remove the payload so that it's removed from the filters
    return "";
  } else {
    return value;
  }
}

export function GetSelectedFilters(arr, selectedValue) {
  // Update the 'selected' property
  if (!arr) {
    return;
  }
  for (let n of arr) {
    n["selected"] = n.value == selectedValue;
  }
}

export function HandleAllFilters(filters, filterOptions, payload) {
  // NOTE: The *value* of the payload must **always** be a string in order to
  // match the value returned in the application route query.
  //
  // (i.e. DON'T spend 20 minutes debugging by trying to pass actual true and
  // false values like I may have just done!)
  const key = Object.keys(payload)[0];
  // If already selected delete the filter
  payload[key] = HandleDeselectedFilter(filters[key], payload[key]);
  // Update the 'selected' property
  GetSelectedFilters(filterOptions[key], payload[key]);
}
